import { I18nService } from './../i18n/i18n.service';
import { PasswordRecoveryComponent } from './../@shared/dialogs/password-recovery/password-recovery.component';
import { Credentials, LoginResponse, NotificationDTO, ResponseModel } from './../@core/models/login-models';
import { CredentialsService } from './../@core/auth/credentials.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { environment } from '@env/environment';
import { Logger, UntilDestroy, untilDestroyed } from '@core';
import { AuthenticationService } from '../@core/auth/authentication.service';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CondicionesComponent } from '@app/@shared/dialogs/condiciones/condiciones.component';
import { MEDIA_BREAKPOINTS } from '../@core/media.config';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { LOGIN } from '@app/@core/constants/routes.constants';
import { TranslateService } from '@ngx-translate/core';
import {
  CSS_BOX_IMG_LOGIN_GLOBALCREDIT,
  CSS_BOX_IMG_LOGIN_CLIENT_ES,
  LINK_LOGIN_GLOBALCREDIT_INFO,
  LINK_LOGIN_INSTANTCREDIT_INFO,
  LINK_LOGIN_CLIENT_INFO,
  TEXT_LOGIN_BOX_GLOBALCREDIT,
  TEXT_LOGIN_BOX_INSTANTCREDIT,
  TEXT_LOGIN_BOX_CLIENT,
  TEXT_LOGIN_BOX_CLIENT_STRONG,
  LANGUAGE_SPANISH,
  CSS_BANNER_IMG_ES,
  CSS_GRID_BOX_ES,
  CSS_BANNER_BOX_IMG_CLIENT_CAT,
  CSS_BANNER_IMG_CAT,
  CSS_GRID_BOX_CAT,
  CSS_BOX_IMG_LOGIN_INSTANTCREDIT_ES,
  CSS_BOX_IMG_LOGIN_INSTANTCREDIT_CAT,
} from '@app/@core/constants/login.constants';
import { LOCALE_ES } from '@app/@core/constants/common.constants';
import { PasswordExpiredDialogComponent } from '@app/@shared/dialogs/password-expired/password-expired.component';
import { CookieService } from 'ngx-cookie-service';
import { COMMERCIAL_EXTERNAL, LOCALSTORAGE_HASCERTIFIEDPAYMENT } from '@app/@core/constants/users.constants';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';

export interface Image {
  id: string;
  link: string;
  text: string;
  boldText: string;
  cols: number;
  rows: number;
}

const log = new Logger('Login');

@UntilDestroy()
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  version: string | null = environment.version;
  error: boolean = false;
  loginForm!: FormGroup;
  submitted: boolean = false;

  credentialsUser: Credentials;

  screenType: string;
  colsList: number;
  colTileTelephone: number;
  rowTileTelephone: number;
  rowHeightList: string;

  name: string = 'Joe Doe';
  nif: string = '00011100';

  backGroundBanner: String = CSS_BANNER_IMG_ES;
  backGroundGrid: String = CSS_GRID_BOX_ES;

  updateDocumentationURL: boolean = false;
  numSolicitudURL: string = '';

  images: Image[] = [
    {
      id: CSS_BOX_IMG_LOGIN_GLOBALCREDIT,
      text: TEXT_LOGIN_BOX_GLOBALCREDIT,
      boldText: '',
      link: LINK_LOGIN_GLOBALCREDIT_INFO,
      cols: 1,
      rows: 6,
    },
    {
      id: CSS_BOX_IMG_LOGIN_INSTANTCREDIT_ES,
      text: '',
      boldText: '',
      link: '',
      cols: 1,
      rows: 6,
    },
    {
      id: CSS_BOX_IMG_LOGIN_CLIENT_ES,
      text: TEXT_LOGIN_BOX_CLIENT,
      boldText: TEXT_LOGIN_BOX_CLIENT_STRONG,
      link: LINK_LOGIN_CLIENT_INFO,
      cols: 1,
      rows: 6,
    },
  ];

  constructor(
    private router: Router,
    private readonly route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    public breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
    private credentialsService: CredentialsService,
    private loaderGenericService: LoaderGenericService,
    private translateService: TranslateService,
    private cookieService: CookieService
  ) {
    this.createForm();
    this.loginForm.valueChanges.subscribe((selectedValue) => {
      if (this.submitted) {
        this.submitted = false;
        this.loginForm.controls.password.setErrors(null);
        this.loginForm.controls.username.setErrors(null);
        this.loginForm.controls.username.updateValueAndValidity();
        this.loginForm.controls.password.updateValueAndValidity();
      }
    });
  }

  ngOnDestroy(): void {
    this.loaderGenericService.stopSpinner();
  }

  ngOnInit() {
    this.translateService.use(LOCALE_ES);
    this.breakpointObserver
      .observe([
        MEDIA_BREAKPOINTS.XS,
        MEDIA_BREAKPOINTS.SM,
        MEDIA_BREAKPOINTS.MD,
        MEDIA_BREAKPOINTS.LG,
        MEDIA_BREAKPOINTS.XL,
      ])
      .subscribe((state: BreakpointState) => {
        //updateScreen(screenType, colsList, rowHeightList, colTileTelephone, rowTileTelephone)
        if (state.breakpoints[MEDIA_BREAKPOINTS.XS]) {
          this.updateScreen('Mobile', 1, '3.5:0.5', 1, 5);
        } else if (state.breakpoints[MEDIA_BREAKPOINTS.SM]) {
          this.updateScreen('Mobile', 2, '5:1', 2, 5);
        } else if (state.breakpoints[MEDIA_BREAKPOINTS.MD]) {
          this.updateScreen('Tablet', 2, '8:1', 2, 2);
        } else if (state.breakpoints[MEDIA_BREAKPOINTS.LG]) {
          this.updateScreen('Desktop', 4, '3.5:0.5', 3, 1.5);
        } else if (state.breakpoints[MEDIA_BREAKPOINTS.XL]) {
          this.updateScreen('Desktop', 4, '3.5:0.5', 3, 1.5);
        }
      });

    this.translateService.onLangChange.subscribe((language) => {
      if (language.lang === LANGUAGE_SPANISH) {
        this.backGroundBanner = CSS_BANNER_IMG_ES;
        this.backGroundGrid = CSS_GRID_BOX_ES;
        this.images[2].id = CSS_BOX_IMG_LOGIN_CLIENT_ES;
        this.images[1].id = CSS_BOX_IMG_LOGIN_INSTANTCREDIT_ES;
      } else {
        this.backGroundBanner = CSS_BANNER_IMG_CAT;
        this.backGroundGrid = CSS_GRID_BOX_CAT;
        this.images[2].id = CSS_BANNER_BOX_IMG_CLIENT_CAT;
        this.images[1].id = CSS_BOX_IMG_LOGIN_INSTANTCREDIT_CAT;
      }
    });

    this.route.queryParams.subscribe((params) => {
      this.updateDocumentationURL = params['updateDocumentationURL'];
      this.numSolicitudURL = params['numSol'];
    });
  }

  login() {
    this.loaderGenericService.showSpinner();
    //no usamos pipe porque vamos a recoger la llamada entera sin modificar
    new Promise<void>((resolve, reject) => {
      this.authenticationService
        .login(this.loginForm.value)
        .toPromise()
        .then(
          (data) => {
            if (environment.name === 'local-pre') {
              this.cookieService.set('JWT_ACCESS_COOKIE', data.accessToken.token);
              this.cookieService.set('JWT_REFRESH_COOKIE', data.refreshToken.token);
            }
            if (data?.webIsOk === false) {
              const dialogConfig = new MatDialogConfig();
              dialogConfig.width = '90%';
              dialogConfig.maxWidth = '450px';
              dialogConfig.data = { text: data?.msg, icon: 'icon-ic_circle_cross' };
              this.dialog.open(ResponseDialogComponent, dialogConfig);
            } else if (data) {
              localStorage.setItem('expiredAt', JSON.stringify(data));
              this.authenticationService.startRefreshTokenTimer(data);
              localStorage.setItem('TimeBeforeGo', Date.now().toString());
              this.authenticationService
                .userInfo()
                .toPromise()
                .then(
                  (dataUser: Credentials) => {
                    if (dataUser == undefined) {
                      //mostrar el error
                      this.loginForm.controls.password.setErrors({ attributions: true });
                      this.loginForm.controls.username.setErrors({ attributions: true });
                      this.loginForm.markAllAsTouched();
                      //hacer logout
                      reject();
                    } else {
                      this.credentialsUser = dataUser;
                      this.credentialsUser.loginResponse = data;

                      //mostrar popup de aceptar condiciones si es necesario
                      if (dataUser?.acceptance === false) {
                        const dialogConfig = new MatDialogConfig();
                        dialogConfig.width = '90%';
                        dialogConfig.maxWidth = '700px';
                        dialogConfig.data = dataUser;
                        dialogConfig.disableClose = true;

                        const modalDialog = this.dialog.open(CondicionesComponent, dialogConfig);

                        modalDialog.afterClosed().subscribe((result: boolean) => {
                          if (result) {
                            let callResult: ResponseModel;
                            //antes de llamar al endpoint, ponemos el acceptance del sessionStorage = S
                            //Llamaremos al endpoint de aceptar condiciones para hacer un update de la casilla N
                            this.authenticationService
                              .acceptConditions()
                              .toPromise()
                              .then(
                                (result: ResponseModel) => {
                                  callResult = result;
                                  if (result && result.descriptionResponse === 'OK' && result.codeResponse === '000') {
                                    //si la respuesta es OK, ponemos el acceptance del sessionStorage = S
                                    dataUser.acceptance = true;
                                    this.credentialsUser = dataUser;
                                    this.credentialsService.setCredentials(this.credentialsUser, true);
                                    if (this.credentialsUser.userType === COMMERCIAL_EXTERNAL) {
                                      this.checkCertifiedPaymentInExternalCommercial(this.credentialsUser);
                                    } else {
                                      this.checkPassword(this.credentialsUser);
                                    }
                                  }
                                },
                                (error) => {
                                  console.log(error);
                                }
                              )
                              .finally(() => {
                                console.log('finalli dialog: ' + callResult);
                              });
                          } else {
                            this.authenticationService
                              .logout()
                              .subscribe(() => this.router.navigate([LOGIN], { replaceUrl: true }));
                          }
                        });
                      } else {
                        // LLAMAR SERVICIO COMUNICADOS
                        this.credentialsService.setCredentials(this.credentialsUser, true);
                        if (this.credentialsUser.userType === COMMERCIAL_EXTERNAL) {
                          this.checkCertifiedPaymentInExternalCommercial(this.credentialsUser);
                        } else {
                          this.checkPassword(this.credentialsUser);
                        }
                      }
                    }
                  },
                  (error) => {
                    console.log(error);
                  }
                );

              resolve();
            } else {
              this.loginForm.controls.password.setErrors({ incorrect: true });
              this.loginForm.controls.username.setErrors({ incorrect: true });
              this.loginForm.markAllAsTouched();
              //hacer logout
              reject();
            }
          },
          (err) => {
            //this.authenticationService.logout();
            console.log(err);
            //mostrar el error
            this.loginForm.controls.password.setErrors({ incorrect: true });
            this.loginForm.controls.username.setErrors({ incorrect: true });
            this.loginForm.markAllAsTouched();
            //hacer logout
            reject();
          }
        )
        .catch((error) => console.error(error))
        .finally(() => this.loaderGenericService.stopSpinner());
    });
    this.submitted = true;
  }

  private checkCertifiedPaymentInExternalCommercial(credentials: Credentials) {
    let commercialDto = {
      commercialId: this.credentialsUser.userId,
    };
    let hasCertifiedPayment = 'N';
    this.authenticationService
      .hasUsersWithCertifiedPayment(commercialDto)
      .toPromise()
      .then((response: boolean) => {
        if (response) {
          hasCertifiedPayment = 'S';
        }
        localStorage.setItem(LOCALSTORAGE_HASCERTIFIEDPAYMENT, hasCertifiedPayment);
        this.checkPassword(credentials);
      });
  }

  private checkPassword(credentials: Credentials) {
    //redirigir a la pagina de cambiar password si es necesario
    if (credentials.changePassword === true) {
      this.router.navigate(['/password'], {
        replaceUrl: true,
      });
    }

    //si no hay que hacer nada de lo anterior, redirigir al home
    else {
      //COMUNICADOS
      this.authenticationService
        .loadReleasesMandatories()
        .toPromise()
        .then(
          (data: NotificationDTO[]) => {
            if (this.updateDocumentationURL) {
              this.router.navigate(['/requests/update-documentation/', this.numSolicitudURL], {
                queryParams: { docUrl: true },
                replaceUrl: false,
              });
              this.updateDocumentationURL = false;
              this.numSolicitudURL = '';
            } else if (data.length > 0) {
              this.authenticationService.setReleases(data);
              this.router.navigate(['/releases'], { replaceUrl: false });
            } else {
              if (this.credentialsUser.userId == 'techAdmin1') {
                this.router.navigate(['/tech-admin'], { replaceUrl: false });
              } else {
                this.router.navigate(['/home'], { replaceUrl: false });
                if (credentials.expiredPasswordDate != '') {
                  this.openDialogExpiredPass(credentials.expiredPasswordDate);
                }
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  private createForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember: true,
    });
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '500px';

    if (this.loginForm.controls.username.value && this.loginForm.controls.username.value !== '') {
      dialogConfig.data = { username: this.loginForm.controls.username.value };
    }

    this.dialog.open(PasswordRecoveryComponent, dialogConfig);
  }

  openDialogExpiredPass(dateExpired: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '500px';
    dialogConfig.data = dateExpired;
    this.dialog.open(PasswordExpiredDialogComponent, dialogConfig);
  }

  openURL(url: string) {
    window.open(url);
  }

  private updateScreen(
    type: string,
    overallCols: number,
    overallHeightRatio: string,
    telephoneCol: number,
    telephoneRow: number
  ): void {
    this.screenType = type;
    this.colsList = overallCols;
    this.rowHeightList = overallHeightRatio;
    this.colTileTelephone = telephoneCol;
    this.rowTileTelephone = telephoneRow;
  }
}
